import { combineReducers } from "redux";
import Auth from "./Auth";
import Theme from "./Theme";
import Request from "./Request";
import Places from "./Places";
import Roles from "./Roles";
import Privileges from "./Privileges";
import States from "./States";
import Cities from "./Cities";
import Statuses from "./Statuses";
import Users from "./Users";
import Works from "./Works";
import Comments from "./Comments";

const reducers = combineReducers({
    theme: Theme,
    auth: Auth,
    places: Places,
    states: States,
    cities: Cities,
    roles: Roles,
    works: Works,
    comments: Comments,
    statuses: Statuses,
    privileges: Privileges,
    users: Users,
    request: Request,
});

export default reducers;
